import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import HobbySidebar, { hobbyData } from './HobbySidebar';
import Workspace from './Workspace';

/**
 * Renders the hobby detail view experience.
 *
 * @returns {JSX.Element} The rendered interface.
 */
export default function HobbyDetailView() {
  const { hobbyId, '*': modulePath = '' } = useParams();
  const hobby = hobbyData.find((item) => item.id === hobbyId);

  if (!hobby) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="hobbies-container hobby-detail-page">
      <HobbySidebar activeId={hobby.id} />
      <Workspace key={hobby.id} hobby={hobby} modulePath={modulePath} />
    </div>
  );
}
